import React from "react";
import { SuggestionForm } from "@/components/SuggestionBox";
import { Lightbulb } from "lucide-react";

export default function Suggestions() {
  return (
    <div className="max-w-xl mx-auto px-4 py-10">
      <div className="flex items-center gap-2 mb-2">
        <span className="w-11 h-11 rounded-xl bg-thali-saffron text-white grid place-items-center shadow-btn-saffron"><Lightbulb className="w-5 h-5" /></span>
        <h1 className="text-3xl md:text-4xl font-heading font-extrabold">Suggestion Box</h1>
      </div>
      <p className="text-thali-ink/70 mb-6">Your ideas shape this tool. Tell us what would make PM POSHAN work easier for you.</p>
      <div className="card-thali">
        <SuggestionForm />
      </div>
    </div>
  );
}
